<div class="container">
    <div class="section-title">
        <h2>{{'main_title_mode' | translate}}</h2>
        <div class="bar"></div>
        <p>{{'sub_title_mode' | translate}}</p>
    </div>

    <div class="tab pricing-list-tab">
        <ul class="tabs">
            <li><a class="mode_solo" href="#">Solo</a></li>
            <li><a href="#">Team Building</a></li>
        </ul>

        <div class="tab_content">
            <div class="tabs_item">
                <div class="row">
                    <div class="col-lg-5 col-md-6" style=" margin: 0 auto;">
                        <div class="single-pricing-table">
                            <div class="pricing-header">
                                <h3>{{'banner_solo' | translate}}</h3>
                            </div>

                            <!-- <div class="price">
                                <sup>$</sup>33 <sub>/ monthly</sub>
                            </div> -->

                            <ul class="pricing-features">
                                <li><fa-icon [icon]="faCheck" size="lg"></fa-icon> {{'solo_1' | translate}}</li>
                                <li><fa-icon [icon]="faCheck" size="lg"></fa-icon> {{'solo_2' | translate}}</li>
                                <li><fa-icon [icon]="faCheck" size="lg"></fa-icon> {{'solo_3' | translate}}</li>
                                <li><fa-icon [icon]="faCheck" size="lg"></fa-icon> {{'solo_4' | translate}}</li>
                                <li><fa-icon [icon]="faCheck" size="lg"></fa-icon> {{'solo_5' | translate}}</li>
                                <li><fa-icon [icon]="faCheck" size="lg"></fa-icon> {{'solo_6' | translate}}</li>
                            </ul>

                            <!-- <div class="pricing-btn">
                                <a routerLink="/" class="default-btn">Purchase <span></span></a>
                            </div> -->
                        </div>
                    </div>

                    <!-- <div class="col-lg-4 col-md-6">
                        <div class="single-pricing-table">
                            <div class="pricing-header">
                                <h3>Personal</h3>
                            </div>

                            <div class="price">
                                <sup>$</sup>69 <sub>/ monthly</sub>
                            </div>

                            <ul class="pricing-features">
                                <li><i class="fas fa-check"></i> Extra features</li>
                                <li><i class="fas fa-check"></i> Lifetime free support</li>
                                <li><i class="fas fa-check"></i> Upgrate options</li>
                                <li><i class="fas fa-check"></i> Full access</li>
                                <li><i class="fas fa-check"></i> Web design</li>
                                <li><i class="fa fa-times"></i> App design</li>
                                <li><i class="fa fa-times"></i> Web developement</li>
                            </ul>

                            <div class="pricing-btn">
                                <a routerLink="/" class="default-btn">Purchase <span></span></a>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6">
                        <div class="single-pricing-table">
                            <div class="pricing-header">
                                <h3>Business</h3>
                            </div>

                            <div class="price">
                                <sup>$</sup>99 <sub>/ monthly</sub>
                            </div>

                            <ul class="pricing-features">
                                <li><i class="fas fa-check"></i> Extra features</li>
                                <li><i class="fas fa-check"></i> Lifetime free support</li>
                                <li><i class="fas fa-check"></i> Upgrate options</li>
                                <li><i class="fas fa-check"></i> Full access</li>
                                <li><i class="fas fa-check"></i> Web design</li>
                                <li><i class="fas fa-check"></i> App design</li>
                                <li><i class="fa fa-times"></i> Web developement</li>
                            </ul>

                            <div class="pricing-btn">
                                <a routerLink="/" class="default-btn">Purchase <span></span></a>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>

            <div class="tabs_item">
                <div class="row">
                    <div class="col-lg-5 col-md-6" style=" margin: 0 auto;">
                        <div class="single-pricing-table">
                            <div class="pricing-header">
                                <h3>{{'banner_teambuilding' | translate}}</h3>
                            </div>

                            <!-- <div class="price">
                                <sup>$</sup>33 <sub>/ yearly</sub>
                            </div> -->

                            <ul class="pricing-features">
                                <li><fa-icon [icon]="faCheck" size="lg"></fa-icon> {{'team1' | translate}}</li>
                                <li><fa-icon [icon]="faCheck" size="lg"></fa-icon> {{'team2' | translate}}</li>
                                <li><fa-icon [icon]="faCheck" size="lg"></fa-icon> {{'team3' | translate}}</li>
                                <li><fa-icon [icon]="faCheck" size="lg"></fa-icon> {{'team4' | translate}}</li>
                                <li><fa-icon [icon]="faCheck" size="lg"></fa-icon> {{'team5' | translate}}</li>
                                <li><fa-icon [icon]="faCheck" size="lg"></fa-icon> {{'team6' | translate}}</li>
                                <li><fa-icon [icon]="faCheck" size="lg"></fa-icon> {{'team7' | translate}}</li>
                                <li><fa-icon [icon]="faCheck" size="lg"></fa-icon> {{'team8' | translate}}</li>
                                <li><fa-icon [icon]="faCheck" size="lg"></fa-icon> {{'team9' | translate}}</li>
                            </ul>

                            <!-- <div class="pricing-btn">
                                <a routerLink="/" class="default-btn">Purchase <span></span></a>
                            </div> -->
                        </div>
                    </div>

                    <!-- <div class="col-lg-4 col-md-6">
                        <div class="single-pricing-table">
                            <div class="pricing-header">
                                <h3>Personal</h3>
                            </div>

                            <div class="price">
                                <sup>$</sup>69 <sub>/ yearly</sub>
                            </div>

                            <ul class="pricing-features">
                                <li><i class="fas fa-check"></i> Extra features</li>
                                <li><i class="fas fa-check"></i> Lifetime free support</li>
                                <li><i class="fas fa-check"></i> Upgrate options</li>
                                <li><i class="fas fa-check"></i> Full access</li>
                                <li><i class="fas fa-check"></i> Web design</li>
                                <li><i class="fas fa-check"></i> App design</li>
                                <li><i class="fa fa-times"></i> Web developement</li>
                            </ul>

                            <div class="pricing-btn">
                                <a routerLink="/" class="default-btn">Purchase <span></span></a>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6">
                        <div class="single-pricing-table">
                            <div class="pricing-header">
                                <h3>Business</h3>
                            </div>

                            <div class="price">
                                <sup>$</sup>99 <sub>/ yearly</sub>
                            </div>

                            <ul class="pricing-features">
                                <li><i class="fas fa-check"></i> Extra features</li>
                                <li><i class="fas fa-check"></i> Lifetime free support</li>
                                <li><i class="fas fa-check"></i> Upgrate options</li>
                                <li><i class="fas fa-check"></i> Full access</li>
                                <li><i class="fas fa-check"></i> Web design</li>
                                <li><i class="fas fa-check"></i> App design</li>
                                <li><i class="fas fa-check"></i> Web developement</li>
                            </ul>

                            <div class="pricing-btn">
                                <a routerLink="/" class="default-btn">Purchase <span></span></a>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>
